// A short two-note chime (WebAudio, no file). Muting is per device.
import { useCallback, useState } from 'react';

let ctx = null;

export function chime(kind = 'ready') {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = ctx || new AC();
    if (ctx.state === 'suspended') ctx.resume();
    const notes = kind === 'new' ? [660, 880] : kind === 'alert' ? [880, 660, 880] : [784, 1046];
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      const start = ctx.currentTime + i * 0.16;
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.25, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.3);
      osc.connect(gain).connect(ctx.destination);
      osc.start(start);
      osc.stop(start + 0.32);
    });
  } catch (e) {
    // no audio on this device
  }
}

export function useSoundPref(key = 'dining_sound') {
  const [on, setOn] = useState(() => {
    try { return localStorage.getItem(key) !== 'off'; } catch (e) { return true; }
  });
  const toggle = useCallback(() => {
    setOn((v) => {
      const next = !v;
      try { localStorage.setItem(key, next ? 'on' : 'off'); } catch (e) { /* ignore */ }
      if (next) chime('new');
      return next;
    });
  }, [key]);
  return [on, toggle];
}
